var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "reactivateClient",
    attrs: {
      id: "reactivate-client-modal",
      "modal-dialog-scrollable": false,
      "footer-close-button-text": _vm.$t("global.words.no"),
      "modal-dialog-size": "md",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("inactive-clients.reactivate")) +
                  "\n      " +
                  _vm._s(_vm.$tc("global.doorr.client", 1)) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("inactive-clients.reactivateClientSubtitle")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "button",
              {
                ref: "reactivateButton",
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.reactivate },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("global.words.yes")) + "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }